export default __webpack_public_path__ + "static/media/nut-comic-1.b284dc26.png";